import { render } from "./PerfilUsuarioModal.vue?vue&type=template&id=17a7adb8&scoped=true&ts=true"
import script from "./PerfilUsuarioModal.vue?vue&type=script&lang=ts"
export * from "./PerfilUsuarioModal.vue?vue&type=script&lang=ts"

import "./PerfilUsuarioModal.vue?vue&type=style&index=0&id=17a7adb8&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a7adb8"]])

export default __exports__